import React, {Component} from 'react';
import classNames from 'classnames';
import {subscribe} from 'klaviyo-subscribe';
import {email as emailRegex} from 'magic-tricks/lib/regex';

const INITIAL_STATE = {
	email: '',
	showInvalidEmailError: false,
	errorMessage: null,
	isSubmitting: false,
	isSuccess: false,
};

export default class NewsletterMinimal extends Component {
	constructor() {
		super();

		this.state = {...INITIAL_STATE};
	}

	onChangeEmail = event => {
		const {showInvalidEmailError} = this.state;

		this.setState({
			email: event.target.value,
			showInvalidEmailError: showInvalidEmailError
				? !emailRegex.test(event.target.value)
				: showInvalidEmailError,
		});
	};

	onSubmit = event => {
		event.preventDefault();

		const {email} = this.state;
		const {klaviyoListId} = this.props;

		if (!emailRegex.test(email)) {
			this.setState({
				showInvalidEmailError: true,
				isSubmitting: false,
			});

			return;
		}

		this.setState({
			isSubmitting: true,
			showInvalidEmailError: false,
		});

		subscribe(klaviyoListId, email)
			.then(response => {
				if (response.errors.length) {
					this.setState({
						isSubmitting: false,
						errorMessage: response.errors.join(' '),
					});
				} else {
					this.setState({
						isSubmitting: false,
						isSuccess: true,
					});
				}
			})
			.catch(error => {
				console.log(error);

				this.setState({
					isSubmitting: false,
					errorMessage: 'Uh oh, an error occured.',
				});
			});
	};

	render() {
		const {
			klaviyoListId, // eslint-disable-line
			...props
		} = this.props;

		const {
			email,
			isSubmitting,
			showInvalidEmailError,
			errorMessage,
			isSuccess,
		} = this.state;

		if (isSuccess) {
			return (
				<p className="tr mt2 serif--xs serif--sm--md">
					Received with thanks.
				</p>
			);
		}

		return (
			<form {...props} onSubmit={this.onSubmit}>
				<div className="newsletter__container mla tr">
					<label
						htmlFor="newsletter-email"
						className="db serif--xs serif--sm--md">
						Newsletter
					</label>

					<input
						id="newsletter-email"
						name="email"
						type="email"
						className={classNames('italic--xs italic--sm--md', {
							loading: isSubmitting,
						})}
						placeholder="Enter your email address"
						value={email}
						onChange={this.onChangeEmail}
					/>
					<span className="italic--xs italic--sm==md"> / </span>
					<button
						disabled={isSubmitting}
						className={classNames(' serif--xs serif--sm--md', {
							loading: isSubmitting,
						})}
						name="signup"
						type="submit">
						Enter
					</button>
				</div>
				{(showInvalidEmailError || errorMessage) && (
					<p className="mt1 serif--xs serif--sm--md color--red">
						{errorMessage
							? errorMessage
							: showInvalidEmailError
							? 'Please enter a valid email.'
							: null}
					</p>
				)}
			</form>
		);
	}
}
